import React, { ReactNode } from "react";
import { createClasses } from "@bloomberg/media-ui-core";

import styles from "./styles.module.css";

export interface ZoneModuleProps {
  moduleId?: string;
  className?: string;
  children?: ReactNode;
}

export const ZoneModule: React.FC<ZoneModuleProps> = ({
  moduleId = "zone_module",
  className,
  children,
}) => {
  const cx = createClasses([styles.zoneModule, className]);

  return (
    <div data-column-id={moduleId} data-component="zone-module" className={cx}>
      {children}
    </div>
  );
};
